import { root, id } from './move';

export const move = {
  ...root,
  id,
};
